module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "storm-clouds"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.65347in",
      "height": "0.40625in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Back again…and I’m compelled to say, I feel storm clouds coming. I mean, for "), _c('em', [_vm._v("all of us")]), _vm._v(". I don’t share this with my students; they have enough problems and anxieties at their age. But I think you can handle it.")]), _vm._v(" "), _c('p', [_vm._v("Earlier, I expressed skepticism about our national obsession with "), _c('em', [_vm._v("Manifest Destiny")]), _vm._v(", our perceived greatness, and our willingness to fight for it. But frankly, my concern extends beyond that misguided nonsense.")]), _vm._v(" "), _c('p', [_vm._v("My sense of ill winds blowing is partly based on what my oldest, Paul, tells me. He’s my ‘canary in the coal mine’ so to speak – an army corporal, stationed just a few miles south at Fort Sill in Lawton. "), _c('em', [_vm._v("It’s a field artillery base")]), _vm._v(". And now, Paul has constant headaches from hearing those loud guns going off, morning and night. I’m talking about cannons and howitzers and rocket launchers. Tons and tons of new hardware coming in.")]), _vm._v(" "), _c('p', [_vm._v("And why is that? Just a theory but last Sunday, I read in the "), _c('em', [_vm._v("New York Times")]), _vm._v(" where Washington politicians are doubling down on North Vietnam. They call it ‘escalation’ which could explain the recent quantity of my drinking.")]), _vm._v(" "), _c('p', [_vm._v("I guess the Pentagon thinks hundreds of military advisors aren’t enough. We can’t let those Chinese communists run amok, can’t let those dominoes fall. I swear, the moment LBJ was sworn in, Ho Chi Minh got a huge target on his back.")]), _vm._v(" "), _c('p', [_vm._v("I’m starting to worry about "), _c('em', [_vm._v("our")]), _vm._v(" boys in uniform. It feels like we’re heading for a new season of insanity. My daughter, Brenda (who now prefers to be called Bren, by the way) tells me I’m jumping to conclusions. "), _c('em', [_vm._v("Maybe")]), _vm._v(". But I’m a student of American history. And I’ve seen this story play out too many times.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Herman T. Lace")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("December 3, 1963")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.65347in",
      "height": "0.40625in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Sampson Whitefeather is in full warrior mode. After filling the spray tank of his crop duster at a refueling site near the Red River, he’s back to cruising altitude for a final top spraying sprint before continuing north toward his Comanche County home.")]), _vm._v(" "), _c('p', [_vm._v("While former Lieutenant Whitefeather and his great grandfather, Chief Quanah Parker, shared a fierce, combative spirit in their youth, they were also late-life architects of white appeasement.")]), _vm._v(" "), _c('p', [_vm._v("In truth, Sampson Whitefeather led two distinct lives: One is on the ground in Medicine Park, where he’s a token of decorum and status-quo citizenship, keeping his tribe integrated into the white Christian community. Up in the air, however, Sampson lets Quanah’s ‘warrior blood’ flow through his veins – often smearing his face with war paint and pretending to dump hundreds of gallons of chemical fury on those who slaughtered and oppressed his people.")]), _vm._v(" "), _c('p', [_vm._v("Sampson clearly sees the whimsy in these pesticide fantasies. He also has the good sense to keep them to himself.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.65347in",
      "height": "0.40625in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("On this particularly muggy and blustery June afternoon, Sampson the ‘Sky Chief’ senses a threatening storm front moving in. He surveys the dark, greenish clouds rapidly moving toward him, several miles from the east. Leaves and branches churn along the ground below.")]), _vm._v(" "), _c('p', [_vm._v("What seems like a heartbeat later, Sampson’s vintage bi-plane is buffeted by severe gusts of wind, followed by a shower of baseball-sized hailstones pounding its wings.")]), _vm._v(" "), _c('p', [_vm._v("Bam! Whack! A large chunk of ice crashes into the propeller – halting its spin and sending shards of metal into the air.")]), _vm._v(" "), _c('p', [_vm._v("As Sampson anxiously searches the ground for a spot to land, he feels the ominous, otherworldly force of a tornado funnel approaching his plane.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Can I get down?")]), _vm._v(" he wonders, trying to remain calm, trying to stay in hyper-focused combat mode. Could he wrestle his wounded craft to the ground without it busting into pieces?")]), _vm._v(" "), _c('p', [_vm._v("Those were Sampson Whitefeather’s last thoughts on that calamitous afternoon.")]), _vm._v(" "), _c('p', [_vm._v("His mind suddenly freezes when a flying chunk of ice crashes into his right temple, sending his gray Stetson skyward.")]), _vm._v(" "), _c('p', [_vm._v("The lights go out as churning storm clouds engulf his plane.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "margin-bottom": "25px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.65347in",
      "height": "0.40694in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba74c016","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0011.vue
// module id = 108
// module chunks = 0